import $ from 'jquery';


class Dashboard {
	
	constructor() {
		if ($("#dashboard").length > 0) {
			this.init();
		}
	}

	init() {

		Vue.component("stream", () => import("../components/Stream.vue"));
		
		
		$("#dashboard_year").change((e) => {
	        let year = $("#dashboard_year").val();
	        $("#award_nights").html("Loading...");

	        $.ajax({
	        	data:{
	        		op:"getAwards",
	        		year: year
	        	},
	        	success: (result, _) => {
	        		$("#award_nights").html(result.html);
	        	}
	        })
	    }).change();


		this.data = {stream: {}, dates: []};


		this.vm = new Vue({
	        el: "#stream",
	        data: this.data,
	        methods: {
	        	
	        }
	    });


		$.ajax({
			data:{
				op: "getStream"
			},
			success: result => {
				this.data.stream = result.events;
				this.data.dates = Object.keys(result.events).reverse();
			}

		})

	}

}

export default Dashboard;
